import { useLingui } from '@lingui/react/macro'
import { RevisionFamilyDropdown } from 'features/knowledgeDocumentViewer/components/metadata/RevisionFamilyDropdown'
import {
  isRevisionFamilyMemberOpenable,
  revisionFamilyHasNewerRevision,
  revisionFamilyMemberMenuItem,
  type RevisionFamilyMemberView,
} from 'features/knowledgeDocumentViewer/utils/pageRevisionFamily'
import { formatRevisionLabel } from 'features/knowledgeDocumentViewer/utils/revisionHelpers'
import React from 'react'

export type PageRevisionFamilyDropdownProps = {
  members: readonly RevisionFamilyMemberView[]
  isLoading: boolean
  onSelectMember: (member: RevisionFamilyMemberView) => void
}

export function PageRevisionFamilyDropdown({
  members,
  isLoading,
  onSelectMember,
}: PageRevisionFamilyDropdownProps): React.ReactElement {
  const { t } = useLingui()
  const isOutdated = revisionFamilyHasNewerRevision(members)
  const currentCode = members.find((member) => member.isCurrent)?.revisionCode

  return (
    <RevisionFamilyDropdown
      revisions={members}
      toMenuItem={(member) =>
        revisionFamilyMemberMenuItem(
          member,
          isRevisionFamilyMemberOpenable(member)
        )
      }
      isOutdated={isOutdated}
      isLoading={isLoading}
      triggerLabel={formatRevisionLabel(currentCode)}
      outdatedTooltip={t`A newer revision is available`}
      size='xs'
      onSelectRevision={onSelectMember}
    />
  )
}
